import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import { useNavigate } from 'react-router-dom';

export default function ScrollableTabsButtonVisible({
  
  tabs,
  setTabs,
  value,
  setValue,
}) {
  const navigate = useNavigate()
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
    
    navigate(tabs[newValue].target); 
  };
  const handleAddTab = () => {
    const newTabs = [...tabs, { label: `Home`, target: '/' }];
    setTabs(newTabs);
  };

  const handleDeleteTab = (index) => {
    const newTabs = tabs.filter((_, i) => i !== index);
    setTabs(newTabs);

    // Adjust the value if the deleted tab was selected
    if (value === index) {
      setValue(Math.min(index, newTabs.length - 1));
      if (newTabs.length > 0) {
        navigate(newTabs[Math.min(index, newTabs.length - 1)].target);
      } else {
        handleAddTab()
        navigate('/'); // Navigate to the home page if there are no tabs left
      }
    }
  };
  useEffect(() =>{
    if(value) {
      
    let confirm = false;
    tabs.map((tab, index) =>{
      if(index === value) {
        confirm = true
      }
    })
    if(confirm === false && value > 0) {
      setValue(value - 1);
      console.log('new value', (value - 1))
    }
    }else {
      setValue(0)
    }
  }, [value, tabs])
  return (
    <>
    
    <div style={{maxWidth: '100%'}} className='mobile-hide'>
    <Box
      sx={{
        flexGrow: 1,
        marginLeft: 1,
        marginRight: 1,
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons
        aria-label="visible arrows tabs example"
        sx={{
            maxWidth: '100%',
          [`& .${tabsClasses.scrollButtons}`]: {
            '&.Mui-disabled': { opacity: 0.3 },
          },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {tab.label}
                {value === index && (
                  <IconButton
                    sx={{
                      marginLeft: 1,
                      fontSize: '18px', // Adjust the size as needed
                    }}
                    onClick={() => handleDeleteTab(index)}
                  >
                    <ClearIcon  fontSize="small"  />
                  </IconButton>
                )}
              </Box>
            }
          />
        ))}
        <IconButton onClick={handleAddTab} style={{width: 40, height: 40, marginTop: 10}}>
            +
        </IconButton>
      </Tabs>
    </Box>
    </div>
    </>
  );
}
